module.exports = "<p>Add your privacy policy here!</p>\n"